// 🔧 solutions.js
// ✅ Purpose: Public marketing hub page for Let's Go Vote solutions
// ✅ Features:
// - Adds SEO title and meta description with Helmet
// - Pulls solution cards from centralized marketing_pages.js
// - Gives users and search engines a clean path to each solution page
// - Links to the event request page

import React from "react";
import { Link } from "react-router-dom";
import { MARKETING_PAGE_LIST, PUBLIC_PAGE_SEO } from "../../constants/marketing_pages";
import SeoHead from "../../components/seo_head";

const Solutions = () => {
  return (
    <>
      <SeoHead {...PUBLIC_PAGE_SEO.solutions} />

      <section id="top-content" className="container-fluid py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 text-start">
              <div className="text-uppercase text-primary fw-bold mb-2">
                Solutions
              </div>

              <h1 className="display-4 fw-bold mb-3">
                Voting tools for real-world events
              </h1>

              <p className="lead text-muted">
                Let&apos;s Go Vote supports car shows, art shows, pet contests,
                school elections, silent auctions, and other events that need
                simple mobile voting.
              </p>

              <Link to="/request_event" className="btn btn-primary btn-lg mt-3">
                Request Your Event
              </Link>
            </div>
          </div>

          {MARKETING_PAGE_LIST.map((group) => (
            <div className="mb-5" key={group.group}>
              <h2 className="h3 text-start mb-3">
                {group.group}
              </h2>

              <div className="row g-4">
                {group.pages.map((solution) => (
                  <div className="col-md-6 col-lg-4" key={solution.key}>
                    <div className="white-section p-4 rounded shadow-sm bg-white h-100 text-start">
                      <h3 className="h4">
                        {solution.title}
                      </h3>

                      <p className="text-muted">
                        {solution.description}
                      </p>

                      <Link to={solution.path} className="btn btn-outline-primary">
                        Learn More
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Solutions;
